<template>
  <div>
    <v-dialog
      v-model="show"
      content-class="crud-dialog"
      persistent
      max-width="440px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 class="text-h5">Calculate Capital Gains Tax</h2>
            </v-col>
            <v-col cols="1">
              <v-icon class="close" color="black" @click.stop="closeDialog">{{
                icons.mdiClose
              }}</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text v-if="show" class="crud-card-text">
          <div class="calculator-container">
            <v-col
              xl="6"
              lg="6"
              md="12"
              sm="12"
              xs="12"
              :class="mobileClass"
              class="calculator-column make-full-width this-one"
            >
              <v-col cols="12" class="make-full-width">
                <!-- <v-row class="capital-gains-tax-calculator-header">
                  <p>Add your values etc etc to use this calculator message</p>
                </v-row> -->
                <v-row class="summary-of-assets-container flex-column">
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="purchase_price"
                        name="purchase_price"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyPurchasePriceValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('purchase-price')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('purchase-price')"
                          @blur="handleBlur('purchasePriceValue')"
                          :name="'purchase_price'"
                          :hint="getHint('purchase-price')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="improvement-costs"
                        name="improvement-costs"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyImprovementCostValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('improvement-costs')"
                          @focus="handleFocus('improvement-costs')"
                          @blur="handleBlur('improvementCostValue')"
                          :name="'improvement-costs'"
                          :hint="getHint('improvement-costs')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="sale-price"
                        name="sale-price"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencySalePriceValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('sale-price')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('sale-price')"
                          @blur="handleBlur('salePriceValue')"
                          :name="'sale-price'"
                          :hint="getHint('sale-price')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="primary-residence"
                        name="primary-residence"
                        class="w-100"
                      >
                        <ListSelect
                          v-model="inputs.primaryResidenceValue"
                          :label="getTitle('primary-residence')"
                          :items="primaryResidenceItems"
                          @focus="handleFocus('primary-residence')"
                          @blur="handleBlur('primaryResidenceValue')"
                          :name="'primary-residence'"
                          :hint="getHint('primary-residence')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="entity-type"
                        name="entity-type"
                        class="w-100"
                      >
                        <ListSelect
                          v-model="inputs.entityTypeValue"
                          :label="getTitle('entity-type')"
                          :items="entityTypeValueItems"
                          @focus="handleFocus('entity-type')"
                          @blur="handleBlur('entityTypeValue')"
                          :name="'entity-type'"
                          :hint="getHint('entity-type')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="gross-annual-income"
                        name="gross-annual-income"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyGrossAnnualIncomeValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('gross-annual-income')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('gross-annual-income')"
                          @blur="handleBlur('grossAnnualIncomeValue')"
                          :name="'gross-annual-income'"
                          :hint="getHint('gross-annual-income')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="capital-gains-losses"
                        name="capital-gains-losses"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyCapitalGainsLossesValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('capital-gains-losses')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('capital-gains-losses')"
                          @blur="handleBlur('capitalGainsLossesValue')"
                          :name="'capital-gains-losses'"
                          :hint="getHint('capital-gains-losses')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <div
                        class="capital-gains-tax-total"
                        :class="{ calculated: submitted }"
                      >
                        <div><h4>Total</h4></div>
                        <div class="total-value">
                          <h4>R {{ currencyTaxTotalValue }}</h4>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center justify-center center-row button-row"
                  >
                    <GradientButton
                      @gradientButtonClicked="submit"
                      :title="determineButtonText()"
                      :small="isMobile"
                      :callout="'right'"
                      :fill="!submitted"
                      class="mt-10"
                    />
                    <GradientButton
                      v-if="submitted"
                      @gradientButtonClicked="closeDialog"
                      :title="'Done'"
                      class="ml-3 mt-10"
                    />
                  </v-row>
                </v-row>
              </v-col>
            </v-col>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    formatCurrency,
    parseCurrency,
    isNumberCheck,
  } from '@/constants/js/currency-input';
  import { tooltipContent } from '@/constants/js/tooltip-content';
  import CapitalTaxGainsCalculator from './CapitalTaxGainsCalculator.vue';
  import { formHelperMixin } from '@/mixins/form-helper-mixin';

  export default {
    name: 'CapitalGainsTaxDialog',
    components: {
      CapitalTaxGainsCalculator,
    },
    mixins: [formHelperMixin],
    props: {
      value: { type: Boolean },
    },
    data() {
      return {
        inputs: {
          purchasePriceValue: 0,
          improvementCostValue: 0,
          salePriceValue: 0,
          primaryResidenceValue: null,
          entityTypeValue: null,
          grossAnnualIncomeValue: 0,
          capitalGainsLossesValue: 0,
          taxTotalValue: 0,
        },
        focusedField: null,
        buttonLoading: false,
        submitted: false,
        showRequestACallDialog: false,
        showRightColumn: true,
        primaryResidenceItems: [
          { text: 'Yes', value: true },
          { text: 'No', value: false },
        ],
        entityTypeValueItems: [
          { text: 'Individual', value: 'INDIVIDUAL' },
          { text: 'Trust', value: 'TRUST' },
          { text: 'Company', value: 'COMPANY' },
        ],
      };
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      isMobile() {
        return this.$isMobileDevice();
      },
      calculatorHeaderWording() {
        return this.isMobile
          ? 'Total liquidity needed in your estate*'
          : 'Total Cost*';
      },
      mobileClass() {
        return {
          'mobile-sizing': this.isMobile,
        };
      },
      imageClass() {
        return {
          'md-image-resize': window.innerWidth <= 1260,
        };
      },
      currencyPurchasePriceValue: {
        get: function () {
          return formatCurrency(this.inputs.purchasePriceValue);
        },
        set: function (newValue) {
          this.inputs.purchasePriceValue = parseCurrency(newValue);
        },
      },
      currencyImprovementCostValue: {
        get: function () {
          return formatCurrency(this.inputs.improvementCostValue);
        },
        set: function (newValue) {
          this.inputs.improvementCostValue = parseCurrency(newValue);
        },
      },
      currencySalePriceValue: {
        get: function () {
          return formatCurrency(this.inputs.salePriceValue);
        },
        set: function (newValue) {
          this.inputs.salePriceValue = parseCurrency(newValue);
        },
      },
      currencyGrossAnnualIncomeValue: {
        get: function () {
          return formatCurrency(this.inputs.grossAnnualIncomeValue);
        },
        set: function (newValue) {
          this.inputs.grossAnnualIncomeValue = parseCurrency(newValue);
        },
      },
      currencyCapitalGainsLossesValue: {
        get: function () {
          return formatCurrency(this.inputs.capitalGainsLossesValue);
        },
        set: function (newValue) {
          this.inputs.capitalGainsLossesValue = parseCurrency(newValue);
        },
      },
      currencyTaxTotalValue: {
        get: function () {
          return formatCurrency(this.inputs.taxTotalValue);
        },
        set: function (newValue) {
          this.inputs.taxTotalValue = parseCurrency(newValue);
        },
      },
      totalCosts: {
        get: function () {
          return formatCurrency(
            Object.values(this.calculatedFees).reduce(
              (acc, val) => +acc + Math.floor(+val),
              0
            )
          );
        },
      },
    },
    methods: {
      getHint(key) {
        if (key === this.focusedField) {
          return tooltipContent.find(item => item.name === key)?.body;
        }
      },
      getTitle(key) {
        return tooltipContent.find(item => item.name === key)?.title;
      },
      submit() {
        this.submitted = true;
        this.performCalculations();
      },
      isNumber(event) {
        isNumberCheck(event);
      },
      handleFocus(vModel) {
        this.focusedField = vModel;
      },
      handleBlur(vModel) {
        this.focusedField = null;
        if (this.inputs[vModel] === '') {
          this.inputs[vModel] = 0;
        }
      },
      determineButtonText() {
        if (!this.isMobile) {
          return !this.submitted
            ? 'Calculate Capital Gains Tax'
            : 'Re-calculate Capital Gains Tax';
        } else {
          return !this.submitted ? 'Calculate' : 'Re-calculate';
        }
      },
      requestACall() {
        this.showRequestACallDialog = true;
      },
      signup() {
        this.$emit('signup');
      },
      showSuccessMessage(success) {
        this.$emit('success', success);
      },
      draftWill() {
        if (this.whitelabel.brand === 'teba') return;
        this.$router.push('/register');
      },
      performCalculations() {
        // Calculate selling costs (5% of sale price)
        const sellingCosts = this.inputs.salePriceValue * 0.05;

        // Calculate base cost
        const baseCost =
          this.inputs.purchasePriceValue +
          this.inputs.improvementCostValue +
          sellingCosts;

        // Calculate raw capital gain
        const capitalGain = this.inputs.salePriceValue - baseCost;

        // Calculate net capital gain after all deductions
        const netCapitalGain = this.calculateNetCapitalGain(capitalGain);

        // Calculate taxable capital gain based on entity type
        const inclusionRate = this.getInclusionRate();
        const taxableCapitalGain = netCapitalGain * inclusionRate;

        // Calculate final tax amount
        const cgtTax = this.calculateTaxAmount(taxableCapitalGain);

        // Update the total display
        this.inputs.taxTotalValue = cgtTax;
      },

      calculateNetCapitalGain(capitalGain) {
        let netGain = capitalGain;

        // Apply primary residence exclusion if applicable
        if (this.inputs.primaryResidenceValue) {
          netGain = Math.max(0, netGain - 2000000); // R2 million exclusion
        }

        // Apply annual exclusion for individuals
        if (this.inputs.entityTypeValue === 'INDIVIDUAL') {
          netGain = Math.max(0, netGain - 40000); // R40,000 annual exclusion
        }

        // Deduct prior year capital losses
        netGain = Math.max(0, netGain - this.inputs.capitalGainsLossesValue);

        return netGain;
      },

      getInclusionRate() {
        switch (this.inputs.entityTypeValue) {
          case 'INDIVIDUAL':
            return 0.4; // 40% inclusion rate for individuals
          case 'TRUST':
          case 'COMPANY':
            return 0.8; // 80% inclusion rate for trusts and companies
          default:
            return 0.4; // Default to individual rate
        }
      },

      calculateTaxAmount(taxableCapitalGain) {
        if (this.inputs.entityTypeValue !== 'INDIVIDUAL') {
          // For trusts and companies, use flat rate of 45%
          return taxableCapitalGain * 0.45;
        }

        // For individuals, use progressive tax brackets
        const income = this.inputs.grossAnnualIncomeValue;
        const taxBrackets = [
          { threshold: 237100, rate: 0.18 },
          { threshold: 370500, rate: 0.26 },
          { threshold: 512800, rate: 0.31 },
          { threshold: 673000, rate: 0.36 },
          { threshold: 857900, rate: 0.39 },
          { threshold: 1817000, rate: 0.41 },
          { threshold: Infinity, rate: 0.45 },
        ];

        let applicableRate = 0.18; // Default to lowest rate
        for (const bracket of taxBrackets) {
          if (income <= bracket.threshold) {
            applicableRate = bracket.rate;
            break;
          }
        }

        return taxableCapitalGain * applicableRate;
      },
      closeDialog() {
        this.show = false;
        setTimeout(() => this.clearDialog(), 300);
      },
      clearDialog() {
        this.$emit('modalClosed');
        this.$emit('taxCalculated', this.inputs.taxTotalValue);
        // Reset the form state
        this.submitted = false;
        this.inputs = {
          purchasePriceValue: 0,
          improvementCostValue: 0,
          salePriceValue: 0,
          primaryResidenceValue: null,
          entityTypeValue: null,
          grossAnnualIncomeValue: 0,
          capitalGainsLossesValue: 0,
          taxTotalValue: 0,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .crud-dialog {
    .crud-card {
      border-radius: 0;
      max-width: 440px;
      margin: 0 auto;
      width: 100%;
    }

    .crud-card-title {
      padding: 20px 24px;
    }

    .crud-card-text {
      padding: 24px;
      overflow-x: hidden;
    }

    .close {
      cursor: pointer;
    }
  }

  .capital-gains-tax-calculator-header {
    margin: 0 5px 30px 5px;
  }
  .calculator-container {
    margin: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding-bottom: 30px;
  }

  .component-container {
    padding: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  .summary-of-assets-container {
    position: relative;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    @media screen and (max-width: 600px) {
      padding: 30px 8px;
    }
  }

  .calculator-card {
    width: 100%;
    box-sizing: border-box;

    @media screen and (max-width: 600px) {
      padding: 40px 12px;
    }
  }

  .calculator-column {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 0;
  }

  .make-full-width {
    width: 100% !important;
    min-width: auto !important;
  }

  .calculator-input {
    font-size: 18px;
  }

  .capital-gains-tax-container {
    padding: 30px 28px;
  }

  .capital-gains-tax-container {
    .calculator-card {
      padding: 15px 24px 40px 24px;
    }
  }

  .card-container {
    border-radius: 0 !important;
  }

  .calculator-card-header {
    height: 110px;
    margin: 0 !important;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    border-radius: 8px;
  }

  .total-cost-title {
    font-size: 24px;
    font-weight: bold;
  }

  .total-cost-amount {
    font-size: 24px;
    font-weight: bold;
    color: white;
  }

  hr {
    border-color: rgba(135, 135, 135, 0.1);
    height: 1px;
  }

  .circle-background {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: rgba(243, 242, 242, 1);
    box-sizing: border-box;
  }

  .info-text {
    font-size: 20px;
    font-weight: 400;
    margin: 30px 0 0 0;
    padding: 0 20px;
  }

  .summary-info {
    font-size: 16px;
    font-weight: 400;
  }

  .please-note {
    padding: 0 25px 0 33px;
    h4 {
      font-weight: 400px;
      font-size: 16px !important;
      line-height: 22.4px !important;
    }
    p {
      font-size: 14px !important;
      font-weight: 300 !important;
      line-height: 19.6px !important;
      color: black !important;
    }
  }

  .mobile-sizing {
    flex: 1 0 100%;
  }

  .md-image-resize {
    width: 100%;
  }

  .calculator-row {
    h4 {
      * {
        display: flex;
        align-items: center;
      }
    }
    padding: 0 12px;
  }
  .calculator-col-padding {
    padding: 0;
  }

  .mobile-tooltip {
    z-index: 1;
    div {
      display: flex;
      align-items: center;
    }
  }

  .button-row {
    margin-top: 55px;
    margin-bottom: -6px;
  }

  .draft-button {
    margin-top: 16px;
    margin-bottom: -7px;
  }

  .info-column {
    padding-top: 38px;
    padding-bottom: 9px;
  }

  .calculator-cost-row {
    margin-bottom: -4px;
    margin-top: 0;
  }

  @media (max-width: 1263px) {
    .calculator-container {
      min-width: auto !important;
    }

    .make-full-width {
      min-width: auto !important;
    }

    .summary-of-assets-container {
      min-width: auto !important;
    }

    .calculator-card {
      h4 {
        font-size: 16px;
        width: 100%;

        span {
          width: auto;
        }
      }

      span:not(.mobile-tooltip) {
        width: 100%;
      }

      .row:not(.center-row) {
        flex-direction: column;
        align-items: unset !important;
      }

      .value-column {
        justify-content: flex-start;

        .values {
          text-align: left !important;
          font-size: 18px;
        }
      }

      .calculator-info {
        margin-top: 0;
      }
    }

    .please-note {
      padding: 0 44px;
      h4 {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
      }
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 140%;
      }
    }
    .calculator-row {
      margin-bottom: -2.4em !important;
      .calculator-label-column {
        padding: 0 0 0 16px;
      }
      .calculator-value-column {
        padding: 0 0 30px 16px;
      }
    }

    .calculator-cost-row {
      :first-child:not(.tooltip-inner) {
        padding-bottom: 0;
      }
    }
    .info-column {
      margin-top: -20px;
    }
    .button-row {
      margin-top: 16px !important;
      margin-bottom: -6px !important;
    }
    .calculator-card-header {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
      padding: 24px 16px;
      .total-cost-row {
        padding: 0;
        flex-basis: 100% !important;
      }
    }
    .calculator-card-header {
      height: auto;
    }
  }

  @media screen and (max-width: 430px) {
    .master-container {
      padding: 0;
    }

    .card-container {
      padding: 17px 0;
    }

    .header-title {
      line-height: 32px !important;
    }

    .summary-of-assets-container {
      padding: 30px 8px !important;
    }
    .component-container {
      padding: 46px 24px;

      .header-title,
      .summary-info {
        padding-left: 23px;
        padding-right: 23px;
      }

      .card-container {
        padding: 17px 0;

        .calculator-row {
          margin: 0;
        }
        .info-row {
          margin-top: 0;
          padding: 0 16px;
        }
      }

      .capital-gains-tax-container {
        .header-title {
          padding-left: 10px;
          padding-right: 0;
        }
        .card-container {
          .calculator-card-header {
            height: auto;

            .total-cost-row {
              padding: 0;
            }
          }
        }
        .circle-background {
          margin-top: 10px;
          margin-bottom: 8px;
        }
        .mobile-tooltip {
          z-index: unset;
        }
      }

      h3 {
        font-size: 28px;
      }
      .heading-row {
        h3 {
          margin-top: 11px;
        }
      }
      .heading-paragraph {
        margin: 28px 0;
      }
      .mobile-sizing {
        padding-top: 0;
        margin-top: -10px;
      }
    }
  }
  //Transitions

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.8s;
    transition-timing-function: ease-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .slide-right-enter-active,
  .slide-right-leave-active {
    transition: transform 0.333s;
    transition-timing-function: ease-in;
  }

  .slide-right-enter,
  .slide-right-leave-to {
    transform: translateX(100%);
    transition-delay: 3.33s;
  }

  .slide-right-enter-to,
  .slide-right-leave {
    transform: translateX(0);
  }
  .total-cost-row {
    flex-basis: 100% !important;
  }

  @media only screen and (min-device-width: 0px) and (max-device-width: 812px) {
    .summary-of-assets-container {
      padding: 30px 8px;
      .header-title {
        padding-left: 20px;
        padding-right: 20px;
      }
      .summary-info {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    .summary-of-assets-container {
      padding: 30px 28px;
    }
    .calculator-card {
      padding: 40px 24px;
    }
    .info-row {
      margin-bottom: 1.5em;
    }
    .calculator-card-header {
      height: auto;
    }
    .mobile-tooltip {
      z-index: unset;
    }
  }

  .capital-gains-tax-total {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #f2f2f2;
    border-radius: 5px;
    width: 100%;
    padding: 18px;
    h4 {
      color: white;
    }

    .total-value {
      margin-left: auto;
    }

    &.calculated {
      background-color: var(--v-primary-base);
    }
  }
</style>
